import styled from 'styled-components';

export const CircleBackground = styled.circle`
  fill: ${props => props.theme.colors.link};
  stroke: white;
  cursor: pointer;
`;

export const CircleProgress = styled.circle`
  fill: none;
  stroke: ${props => (props.active ? props.theme.colors.successLight : '#eeeeee')};
  stroke-linecap: round;
  stroke-linejoin: round;
  cursor: pointer;
  transition: stroke-dashoffset 0.5s linear;
`;

export const Text = styled.text`
  fill: #fff;
  font-size: 38px;
  font-weight: 100;
  cursor: pointer;
`;
